import { gql, useLazyQuery, useMutation } from '@apollo/client';
import { getSessionInfo } from '@thoughtspot/session-service';
import _ from 'lodash';
import { useEffect } from 'react';
const getSelfClusterDisplayName = () => {
    return _.get(getSessionInfo(), 'configInfo.selfClusterDisplayName');
};
const GET_LLM_GATEWAY_CONFIG_QUERY = gql `
    query LLMGateway_getConfig {
        LLMGateway_getConfig {
            status
            data {
                mode
                selection
                manualProvider
                effectiveProvider
                updatedAt
            }
            error {
                errorCode
                errorMessage
                status
            }
        }
    }
`;
const GET_TENANT_ORG_MAPPINGS_MUTATION = gql `
    mutation LLMGateway_postTenantOrgMappings(
        $tenantId: String!
        $orgId: String!
        $features: [LLMGatewayFeatureInput]
    ) {
        LLMGateway_postTenantOrgMappings(
            tenantId: $tenantId
            orgId: $orgId
            features: $features
        ) {
            status
            data
            error {
                errorCode
                errorMessage
                status
            }
        }
    }
`;
export const useGetLLMGatewayConfigQuery = () => {
    const [getLlmGatewayConfig, { data, loading, error }] = useLazyQuery(GET_LLM_GATEWAY_CONFIG_QUERY, {
        fetchPolicy: 'no-cache',
        context: {
            headers: {
                'X-TS-Cluster-Name': getSelfClusterDisplayName(),
            },
        },
    });
    return {
        loading,
        error,
        data: data?.LLMGateway_getConfig ?? null,
        getLlmGatewayConfig,
    };
};
export const useGetLLMGatewayTenantOrgMappings = (tenantId, orgId, features) => {
    const [getTenantOrgMappings, { data, loading, error }] = useMutation(GET_TENANT_ORG_MAPPINGS_MUTATION, {
        fetchPolicy: 'no-cache',
        context: {
            headers: {
                'X-TS-Cluster-Name': getSelfClusterDisplayName(),
            },
        },
    });
    useEffect(() => {
        if (tenantId && orgId) {
            getTenantOrgMappings({
                variables: { tenantId, orgId, features: features ?? [] },
            });
        }
    }, [tenantId, orgId, features]);
    return {
        loading,
        error,
        data: data?.LLMGateway_postTenantOrgMappings
            ?.data,
        responseError: data?.LLMGateway_postTenantOrgMappings?.error ?? null,
    };
};
//# sourceMappingURL=llm-gateway-service.js.map